import { peopleRef, skillsRatingRef, technologyRef } from "@/vue-service-database.js";


// UTILITY FOR DB CLEANUP
async function findPeopleToLog() {
	console.log("looking");
	const peopleSnap = await peopleRef
		.once("value")
		.catch((err) => console.log(err));
	const people = peopleSnap.val();
	const promises = Object.keys(people).map(key => {
		console.log("removeing from ", key);
		if (people[key].skills) {
			return peopleRef
				.child(key)
				.child("skills")
				.set(null);
		}
	});
	return Promise.all(promises);
}
function fillPeopleRatedAt() {
	const byPeople = store.getters.skillsRatingByPerson;
	const skillsRatingByTechnology = store.getters.skillsRatingByTechnology;
	//const technologies = store.getters.technology;
	const technologiesReduced = reduceTechnologies(skillsRatingByTechnology);
	const people = store.getters.people;
	const peopleReduced = reducePeople(people);

	// Loop through people to get their skill ratings
	// for each skill
	let countPeople = 0;
	for (let pKey in byPeople) {
		//if(pKey === "-L-hmPOjUimQaeTZDOh7") {
		if (true) {
			//console.log("pKey -LhmPOjUimQaeTZDOh7")
			countPeople++;
			//if(countPeople>15) return true;

			const byPerson = byPeople[pKey];
			const skills = byPerson.skills;
			const personReduced = peopleReduced[pKey];
			if (!(personReduced === undefined)) {
				// console.log("pKey", pKey)
				// console.log("byPeople", byPeople)

				// loop through skills byTechnology
				// and update peopleRatedAt
				let countSkills = 0;
				for (let sKey in skills) {
					countSkills++;
					//if(countSkills>300) return true;
					const skillRating = makeSkillRating(personReduced, skills, sKey);
					// console.log("skillRating", skillRating)

					if (sKey in technologiesReduced) {
						writeSkillsRatingByTechnologyPeopleRatedAt(skillRating, technologiesReduced[sKey]);
					}
				}
			}
		}
	}
}
function writeSkillsRatingByTechnologyPeopleRatedAt(skillRating, technologyReduced) {
	switch (skillRating.Rating) {
	case -1:
		// Not Rated, Do nothing
		// console.log("Do Nothing ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
		break;
	case 0:
		// code block
		// console.log("add ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
		return addPersonToRatedAt0(skillRating, technologyReduced);
		break;
	case 1:
		// code block
		// console.log("add ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
		return addPersonToRatedAt1(skillRating, technologyReduced);
		// break;
	case 2:
		// code block
		// console.log("add ", skillRating.fullName, " to ", skillRating.skillKey, " at ", skillRating.Rating);
		return addPersonToRatedAt2(skillRating, technologyReduced);
		break;
	case 3:
		// code block
		return addPersonToRatedAt3(skillRating, technologyReduced);
		break;
	default:
		// code block
	}
}
function addPersonToRatedAt0(skillRating, technologyReduced) {
	console.log("skillRating.personKey", skillRating.personKey);
	console.log("technologyReduced.peopleRatedAt0", technologyReduced.peopleRatedAt0);
	let peopleRatedAt0 = technologyReduced.peopleRatedAt0 || [];
	// console.log("Object.keys(peopleRatedAt0)", skillRating.skillKey, Object.keys(peopleRatedAt0));
	console.log("peopleRatedAt0 before", peopleRatedAt0);
	if (skillRating.Rating === 0 && !(skillRating.skillKey in peopleRatedAt0)) {
		peopleRatedAt0[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		console.log("peopleRatedAt0 after", peopleRatedAt0);
		skillsRatingRef
			.child("byTechnology")
			.child(skillRating.skillKey)
			.child("peopleRatedAt0")
			.set(peopleRatedAt0);
	}
}
function addPersonToRatedAt1(skillRating, technologyReduced) {
	let peopleRatedAt1 = technologyReduced.peopleRatedAt1 || [];
	console.log("Object.keys(peopleRatedAt1)", skillRating.skillKey, Object.keys(peopleRatedAt1));
	console.log("peopleRatedAt1", peopleRatedAt1);
	console.log("Object.keys(peopleRatedAt1)", Object.keys(peopleRatedAt1));
	console.log("peopleRatedAt1 before", peopleRatedAt1);
	if (skillRating.Rating === 1 && !(skillRating.skillKey in peopleRatedAt1)) {
		peopleRatedAt1[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		console.log("peopleRatedAt1", skillRating.skillKey, peopleRatedAt1[skillRating.personKey]);
		return skillsRatingRef
			.child("byTechnology")
			.child(skillRating.skillKey)
			.child("peopleRatedAt1")
			.set(peopleRatedAt1);
	}
	console.log("peopleRatedAt0 after", peopleRatedAt1);

}
function addPersonToRatedAt2(skillRating, technologyReduced) {
	let peopleRatedAt2 = technologyReduced.peopleRatedAt2 || [];
	console.log("Object.keys(peopleRatedAt2)", skillRating.skillKey, Object.keys(peopleRatedAt2));
	console.log("peopleRatedAt1", peopleRatedAt2);
	console.log("Object.keys(peopleRatedAt2)", Object.keys(peopleRatedAt2));
	if (skillRating.Rating === 2 && !(skillRating.skillKey in peopleRatedAt2)) {
		peopleRatedAt2[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		return skillsRatingRef
			.child("byTechnology")
			.child(skillRating.skillKey)
			.child("peopleRatedAt2")
			.set(peopleRatedAt2);
	}
}
function addPersonToRatedAt3(skillRating, technologyReduced) {
	let peopleRatedAt3 = technologyReduced.peopleRatedAt3 || [];
	console.log("Object.keys(peopleRatedAt3)", skillRating.skillKey, Object.keys(peopleRatedAt3));
	console.log("peopleRatedAt1", peopleRatedAt3);
	console.log("Object.keys(peopleRatedAt3)", Object.keys(peopleRatedAt3));
	if (skillRating.Rating === 3 && !(skillRating.skillKey in peopleRatedAt3)) {
		peopleRatedAt3[skillRating.personKey] = {
			"fullName": skillRating.fullName,
			"email": skillRating.email
		};
		return skillsRatingRef
			.child("byTechnology")
			.child(skillRating.skillKey)
			.child("peopleRatedAt3")
			.set(peopleRatedAt3);
	}
}
function reducePeople(people) {
	const peopleReduced = Object.keys(people).map(pKey => pKey).reduce((acc, pK) => {
		acc[pK] = {
			"fullName": people[pK].fName + " " + people[pK].lName,
			"email": people[pK].email,
			"key": pK
		};
		return acc;
	}, []);
	return peopleReduced;
}
function reduceTechnologies(technologies) {
	const technologiesReduced = Object.keys(technologies).map(tKey => tKey).reduce((acc, tK) => {
		acc[tK] = {
			"peopleRatedAt0": technologies[tK].peopleRatedAt0 || "",
			"peopleRatedAt1": technologies[tK].peopleRatedAt1 || "",
			"peopleRatedAt2": technologies[tK].peopleRatedAt2 || "",
			"peopleRatedAt3": technologies[tK].peopleRatedAt3 || ""
		};
		return acc;
	}, []);
	return technologiesReduced;
}
function makeSkillRating(personReduced, skills, skillKey) {
	return {
		"Rating": skills[skillKey].Rating,
		"fullName": personReduced.fullName,
		"email": personReduced.email,
		"skillKey": skillKey,
		"personKey": personReduced.key
	};
}
async function erasePeopleRatedAt() {
	const skillsSnap = await skillsRatingRef.child("byTechnology").once("value");
	const skills = skillsSnap.val();
	const promises = Object.keys(skills).map(skill => {
		console.log("skill 0", skill);
		return skillsRatingRef.child("byTechnology").child(skill).child("peopleRatedAt0").set(null);
	});
	return Promise.all(promises);
}
function updateSkillsRatingTechs() {
	// Used once to transfer tech info to byPeople array
	let byPeople = store.getters.skillsRatingByPerson;
	let technologies = store.getters.technology;

	let updatedByPeople = {};
	for (let key in byPeople) {
		let person = byPeople[key];
		let updatedPerson = { skills: {} };
		let skills = person.skills;
		for (let techKey in skills) {
			updatedPerson.skills[techKey] = Object.assign({}, skills[techKey], technologies[techKey]);
		}
		updatedByPeople[key] = updatedPerson;
	}

	transferTechDataToByPeople(updatedByPeople);
}
function deleteSkillsRatingByPersonSkillNode(personKey, skillKey) {
	return skillsRatingRef
		.child("byPerson")
		.child(personKey)
		.child("skills")
		.child(skillKey)
		.set(null);
}
function transferTechDataToByPeople(updatedByPeople) {
	skillsRatingRef.child("byPerson").set(updatedByPeople);
}
async function findMissingTechProperties() {
	const peopleSnap = await skillsRatingRef
		.child("byPerson")
		.once("value")
		.catch((err) => console.log(err));
	const people = peopleSnap.val();
	const technologySnap = await technologyRef
		.once("value")
		.catch((err) => console.log(err));
	const technology = technologySnap.val();
	//const peopleKeys = Object.keys(people);
	let missing = [];
	let missingFromTech = [];
	let peopleWithExtraTech = [];
	// let loopCount = 0;
	for (let pK in people) {
		for (let sK in people[pK].skills) {
			// loopCount++;
			// if(loopCount>10) return true;
			// console.log("people[pK].skills[sK].Name", people[pK].skills[sK].Name);
			if(!(sK in technology)){
				missingFromTech.push(sK);
				if(!(pK in peopleWithExtraTech)) peopleWithExtraTech[pK] = sK;
			}
			if (people[pK].skills[sK].Name === undefined) {
				missing.push({
					"pK": pK,
					"sK": sK,
					"Rating": people[pK].skills[sK].Rating
				});
			}
		}
	}
	// console.log("missing", missing);
	//console.log("missingFromTech", missingFromTech);
	console.log("peopleWithExtraTech", peopleWithExtraTech);
	return Promise.all(Object.keys(missing).map(i => {
		if (i >= 0 || i <= 200) {
			const m = missing[i];
			const pK = m.pK;
			const sK = m.sK;
			const Rating = m.Rating;
			const techProperties = technology[sK];
			const newSkillRating = {
				...techProperties,
				Rating
			};
			// console.log("newSkillRating", newSkillRating);
			if(sK == "-M1RA0615SJ-WLM9zJKv"){
				console.log("sK", sK);
				return skillsRatingRef
					.child("byPerson")
					.child(pK)
					.child("skills")
					.child(sK)
					.set(null);

			} else {
				return skillsRatingRef
					.child("byPerson")
					.child(pK)
					.child("skills")
					.child(sK)
					.set(newSkillRating);
			}
		}
	}
	));
}

export {
	findPeopleToLog,
	fillPeopleRatedAt,
	erasePeopleRatedAt,
	deleteSkillsRatingByPersonSkillNode,
	findMissingTechProperties
};


// WEBPACK FOOTER //
// ./src/vue-service-utility.js